module.exports = __webpack_public_path__ + "static/img/big_profits.0bb3449.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/big_profits.png
// module id = MxhD
// module chunks = 2